import { Link as TanStackLink } from "@tanstack/react-router"
import React from "react"

type Search =
  Record<string, unknown> | ((previous: Record<string, unknown>) => Record<string, unknown>)

export type LinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "onClick"> & {
  href?: string
  to?: string
  params?: Record<string, string>
  search?: Search
  disabled?: boolean
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void | boolean
}

const TypedTanStackLink = TanStackLink as unknown as React.ForwardRefExoticComponent<
  LinkProps & React.RefAttributes<HTMLAnchorElement>
>

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  if (props.to) {
    return <TypedLink {...props} ref={ref} />
  }

  return <LegacyLink {...props} ref={ref} />
})

const LegacyLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (props.disabled === true) {
      event.preventDefault()
      event.stopPropagation()
      return
    }

    if (props.onClick?.(event) === false) {
      event.preventDefault()
      event.stopPropagation()
      return
    }
  }

  const {
    onClick: _onClick,
    children: _children,
    to: _to,
    params: _params,
    search: _search,
    ...linkProps
  } = props

  return (
    <a {...linkProps} ref={ref} onClick={handleClick}>
      {props.children || props.title}
    </a>
  )
})

const TypedLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (props.disabled === true) {
      event.preventDefault()
      event.stopPropagation()
      return
    }

    if (props.onClick?.(event) === false) {
      event.preventDefault()
      event.stopPropagation()
      return
    }
  }

  const {
    onClick: _onClick,
    children: _children,
    params: _params,
    search: _search,
    to: _to,
    ...linkProps
  } = props

  return (
    <TypedTanStackLink
      {...linkProps}
      ref={ref}
      to={props.to}
      params={props.params}
      search={props.search}
      disabled={props.disabled}
      onClick={handleClick}
    >
      {props.children || props.title}
    </TypedTanStackLink>
  )
})

Link.displayName = "Link"
LegacyLink.displayName = "LegacyLink"
TypedLink.displayName = "TypedLink"

export default Link
